export default function CTASection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-28 px-6 overflow-hidden">
      {/* Background with Gradient */}
      <div className="absolute inset-0" style={{ background: 'linear-gradient(120deg,#0b5b96,#083f68)' }}>
        <div className="absolute -top-[120px] -left-20 w-[360px] h-[360px] rounded-full bg-white/[.08] blur-[20px]"></div>
        <div className="absolute -bottom-[140px] -right-20 w-[360px] h-[360px] rounded-full bg-white/[.08] blur-[20px]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[760px] mx-auto text-center">
        <h2 className="font-extrabold text-white leading-[1.15] tracking-tight mb-[22px]" style={{ fontSize: 'clamp(2.25rem,4vw,3rem)' }}>
          Ready for a Cleaner Workspace?
        </h2>
        <p className="text-[19px] leading-snug text-white/[.92] max-w-[560px] mx-auto mb-10">
          Get a free quote in minutes. After-hours cleaning that works around your business schedule — so your team walks into spotless every morning.
        </p>
        <button
          onClick={scrollToContact}
          className="group inline-flex items-center gap-3 bg-white text-[#0b5b96] px-10 py-[19px] rounded-full font-extrabold text-[17.5px] shadow-[0_20px_40px_-14px_rgba(0,0,0,0.4)] hover:bg-[#a7c93f] hover:text-[#1c2410] hover:-translate-y-0.5 transition-all duration-250 whitespace-nowrap cursor-pointer"
        >
          Book Your Cleaning Today
          <i className="ri-arrow-right-line"></i>
        </button>
        <p className="text-sm text-white/75 mt-6">
          No commitment required • Free quote in 24 hours
        </p>
      </div>
    </section>
  );
}
